import {useContext} from 'react';

import {envIsServerDeployment} from '../../config';
import {AccountSelectorContext} from '../Search/SearchNav/AccountSelectorContextProvider';
import {type Account, AccountType} from '../Search/SearchNav/types';

export type SelectedAccountOrgScope = {
  organizationId?: string;
  organizationName?: string;
};

export const useSelectedAccountOrgScope = (): SelectedAccountOrgScope & {
  isAccountListLoading: boolean;
} => {
  const accountSelector = useContext(AccountSelectorContext);

  // there is only one default org in single-tenant.
  // return null for the org context in this case.
  if (envIsServerDeployment) {
    return {isAccountListLoading: false};
  }

  const {selectedAccount, accountList, isAccountListLoading} = accountSelector;
  const orgContext = getSelectedAccountOrgScope(selectedAccount, accountList);

  return {
    ...orgContext,
    isAccountListLoading,
  };
};

export const getSelectedAccountOrgScope = (
  selectedAccount: Account | null,
  accountList: Account[]
): SelectedAccountOrgScope | null => {
  if (selectedAccount?.accountType === AccountType.Personal) {
    return {
      organizationId: getPersonalOrgId(selectedAccount, accountList),
      organizationName: selectedAccount.name,
    };
  }

  if (selectedAccount?.id) {
    return {
      organizationId: selectedAccount.id,
      organizationName: selectedAccount.name,
    };
  }

  return null;
};

const getPersonalOrgId = (
  selectedAccount: Account | null,
  accountList: Account[]
) => {
  return (
    selectedAccount?.personalOrgId ??
    accountList.find(
      account =>
        account.accountType === AccountType.Personal &&
        account.personalOrgId != null
    )?.personalOrgId
  );
};
